(window as any).surveylab_survey_scrollbar = undefined;
(window as any).surveylab_datetime_timepicker = undefined;
(window as any).surveylab_datetime_datepicker = undefined;